export enum Roles {
  DEV = 'ROLE_DEVELOPER',
  KASSIR = 'ROLE_KASSIR',
  TEST = 'ROLE_TEST',
  USER = 'ROLE_USER',
}

export type DecodedToken = {
  iat: string;
  exp: string;
  authorities: Roles[];
  sub: string;
  gameKey: string;
  type: 'GAME';
  username: string;
};
